/* Weekend Trip Designs — Theme JS
   ============================================
   No Dawn. No framework. Just WTD.
   ============================================ */

(function () {
  'use strict';

  // ============================================
  // Announcement Bar Rotation
  // ============================================
  var messages = document.querySelectorAll('.wtd-announcement-msg');
  var currentMsg = 0;

  if (messages.length > 1) {
    setInterval(function () {
      messages[currentMsg].classList.remove('active');
      currentMsg = (currentMsg + 1) % messages.length;
      messages[currentMsg].classList.add('active');
    }, 4000);
  }

  // ============================================
  // Mobile Nav Toggle
  // ============================================
  var navToggle = document.querySelector('.wtd-nav-toggle');
  var navLinks = document.querySelector('.wtd-nav-links');

  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navToggle.classList.toggle('active');
      navLinks.classList.toggle('open');
    });

    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (link.classList.contains('wtd-nav-dropdown-trigger')) return;
        navToggle.classList.remove('active');
        navLinks.classList.remove('open');
      });
    });
  }

  // ============================================
  // Mega-nav Dropdown
  // ============================================
  var navBreakpoint = 1000; // hamburger nav at/below this width; keep in sync with base.css
  var dropdownItems = document.querySelectorAll('.wtd-nav-has-dropdown');
  dropdownItems.forEach(function (item) {
    var closeTimeout;
    var megaNav = item.querySelector('.wtd-mega-nav');
    var trigger = item.querySelector('.wtd-nav-dropdown-trigger');
    if (!megaNav || !trigger) return;

    // Desktop: hover intent
    item.addEventListener('mouseenter', function () {
      if (window.innerWidth > navBreakpoint) {
        clearTimeout(closeTimeout);
        item.classList.add('active');
      }
    });

    item.addEventListener('mouseleave', function () {
      if (window.innerWidth > navBreakpoint) {
        closeTimeout = setTimeout(function () {
          item.classList.remove('active');
        }, 200);
      }
    });

    // Mobile: click toggle
    trigger.addEventListener('click', function (e) {
      if (window.innerWidth <= navBreakpoint) {
        e.preventDefault();
        megaNav.classList.toggle('open');
        item.classList.toggle('active');
      }
    });
  });

  // ============================================
  // Nav scroll behavior
  // ============================================
  var nav = document.querySelector('.wtd-nav');
  var announcementBar = document.querySelector('.wtd-announcement-bar');
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  var isTransparent = document.body.classList.contains('wtd-transparent-header');

  if (nav) {
    function onScroll() {
      // Pin nav to top once announcement bar scrolls out
      if (window.scrollY >= announcementHeight) {
        nav.style.top = '0';
      } else {
        nav.style.top = (announcementHeight - window.scrollY) + 'px';
      }

      // Transparent → solid background on homepage
      if (isTransparent) {
        if (window.scrollY > 50) {
          document.body.classList.add('wtd-scrolled');
        } else {
          document.body.classList.remove('wtd-scrolled');
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============================================
  // Scroll-triggered fade-in animations
  // ============================================
  // Auto-add fade-in to key content elements
  var fadeTargets = [
    '.wtd-trust-strip .wtd-trust-items',
    '.wtd-products-grid',
    '.wtd-story-text',
    '.wtd-story-image',
    '.wtd-design-breakout .wtd-section-overline',
    '.wtd-design-breakout h2',
    '.wtd-breakout-grid',
    '.wtd-deans-list-content',
    '.wtd-product-detail',
    '.wtd-product-gallery',
    '.wtd-product-info-grid .wtd-info-columns',
    '.wtd-collection-story-image',
    '.wtd-collection-story-text',
    '.wtd-collection-hero-content',
    '.wtd-up-next-content',
    '.wtd-related-products .wtd-section-overline',
    '.wtd-related-products .wtd-products-grid',
    '.wtd-drop-spotlight-content',
    '.wtd-cart h1',
    '.wtd-shipping-bar',
    '.wtd-section-overline',
    '.wtd-contact-info',
    '.wtd-contact-form-wrap',
    '.wtd-faq-category',
    '.wtd-story-intro',
    '.wtd-story-section',
    '.wtd-story-split-image',
    '.wtd-story-split-text',
    '.wtd-story-quote',
    '.wtd-story-giveback'
  ];

  fadeTargets.forEach(function (selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (!el.classList.contains('wtd-fade-in')) {
        el.classList.add('wtd-fade-in');
      }
    });
  });

  // Stagger product cards for a cascade effect
  document.querySelectorAll('.wtd-product-card').forEach(function (card, i) {
    card.classList.add('wtd-fade-in');
    card.style.transitionDelay = (i % 4) * 0.1 + 's';
  });

  // Stagger breakout points
  document.querySelectorAll('.wtd-breakout-point').forEach(function (point, i) {
    point.classList.add('wtd-fade-in');
    point.style.transitionDelay = i * 0.12 + 's';
  });

  // Stagger trust items
  document.querySelectorAll('.wtd-trust-item').forEach(function (item, i) {
    item.classList.add('wtd-fade-in');
    item.style.transitionDelay = i * 0.1 + 's';
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.wtd-fade-in').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    document.querySelectorAll('.wtd-fade-in').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // ============================================
  // Product Page — Variant Selector
  // ============================================
  var variantDataEl = document.getElementById('productVariantData');
  var variantSelect = document.getElementById('productVariantSelect');

  if (variantDataEl && variantSelect) {
    var variants = JSON.parse(variantDataEl.textContent);
    var priceEl = document.querySelector('.wtd-product-detail-price');
    var addToCartBtn = document.querySelector('.wtd-btn-add-to-cart');
    var productForm = document.getElementById('product-form');

    function getSelectedOptions() {
      var selected = [];
      document.querySelectorAll('.wtd-variant-options').forEach(function (group) {
        var activeBtn = group.querySelector('.wtd-variant-btn.selected');
        selected.push(activeBtn ? activeBtn.dataset.value : null);
      });
      return selected;
    }

    function findVariant(selectedOptions) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++) {
          if (v.options[j] !== selectedOptions[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var selectedOptions = getSelectedOptions();
      var variant = findVariant(selectedOptions);

      if (!variant) return;

      // Sync hidden select
      variantSelect.value = variant.id;

      // Update price
      if (priceEl) {
        if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
          priceEl.innerHTML = '<s>' + formatMoney(variant.compareAtPrice) + '</s> ' + formatMoney(variant.price);
        } else {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      // Update add-to-cart button
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = window.variantStrings.addToCart || 'Add to Cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = window.variantStrings.soldOut || 'Sold Out';
        }
      }

      // Mark sold-out variants visually
      updateSoldOutStates();
    }

    function updateSoldOutStates() {
      document.querySelectorAll('.wtd-variant-options').forEach(function (group) {
        var optionIndex = parseInt(group.dataset.optionIndex, 10);

        group.querySelectorAll('.wtd-variant-btn').forEach(function (btn) {
          var value = btn.dataset.value;

          // Build a test options array using current selections but swapping this option
          var testOptions = getSelectedOptions();
          testOptions[optionIndex] = value;

          var matchingVariant = findVariant(testOptions);
          if (matchingVariant && !matchingVariant.available) {
            btn.classList.add('sold-out');
          } else {
            btn.classList.remove('sold-out');
          }
        });
      });
    }

    document.querySelectorAll('.wtd-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.wtd-variant-options');
        if (group) {
          group.querySelectorAll('.wtd-variant-btn').forEach(function (b) {
            b.classList.remove('selected');
          });
        }
        btn.classList.add('selected');
        updateVariant();
      });
    });

    // Initial sold-out state on page load
    updateSoldOutStates();
  } else {
    // Fallback: pages without variant data (e.g. quick-view) — visual toggle only
    document.querySelectorAll('.wtd-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.wtd-variant-options');
        if (group) {
          group.querySelectorAll('.wtd-variant-btn').forEach(function (b) {
            b.classList.remove('selected');
          });
        }
        btn.classList.add('selected');
      });
    });
  }

  // ============================================
  // Product Page — Thumbnail Gallery (event delegation)
  // ============================================
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.wtd-product-thumb');
    if (!thumb) return;

    var gallery = thumb.closest('.wtd-product-gallery');
    if (!gallery) return;

    gallery.querySelectorAll('.wtd-product-thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');

    var mainImage = gallery.querySelector('.wtd-product-main-image img');
    var thumbImg = thumb.querySelector('img');
    if (mainImage && thumbImg) {
      var newSrc = thumbImg.dataset.full || thumbImg.src;
      mainImage.removeAttribute('srcset');
      mainImage.src = newSrc;
      mainImage.alt = thumbImg.alt;
    }
  });

  // ============================================
  // Product Page — Image Zoom Lightbox with Nav
  // ============================================
  (function () {
    var overlay = document.createElement('div');
    overlay.className = 'wtd-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Zoomed product image');
    overlay.innerHTML =
      '<button class="wtd-zoom-nav wtd-zoom-prev" aria-label="Previous image"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12 4L4 10L12 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="4" y1="10" x2="17" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="wtd-zoom-wrap"><img class="wtd-zoom-img" src="" alt=""><button class="wtd-zoom-close" aria-label="Close zoom">&times;</button></div>' +
      '<button class="wtd-zoom-nav wtd-zoom-next" aria-label="Next image"><svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8 4L16 10L8 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="16" y1="10" x2="3" y2="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    document.body.appendChild(overlay);

    var zoomImg = overlay.querySelector('.wtd-zoom-img');
    var closeBtn = overlay.querySelector('.wtd-zoom-close');
    var prevBtn = overlay.querySelector('.wtd-zoom-prev');
    var nextBtn = overlay.querySelector('.wtd-zoom-next');

    var images = [];
    var currentIndex = 0;

    function collectImages() {
      images = [];
      var thumbs = document.querySelectorAll('.wtd-product-thumb img');
      thumbs.forEach(function (img) {
        var src = img.dataset.full || img.src;
        images.push({ src: src.replace(/width=\d+/, 'width=2000'), alt: img.alt });
      });
    }

    function showImage(index) {
      if (images.length === 0) return;
      currentIndex = (index + images.length) % images.length;
      zoomImg.src = images[currentIndex].src;
      zoomImg.alt = images[currentIndex].alt || '';
      // Hide nav if only one image
      prevBtn.style.display = images.length > 1 ? '' : 'none';
      nextBtn.style.display = images.length > 1 ? '' : 'none';
    }

    function syncMainImage() {
      var thumbs = document.querySelectorAll('.wtd-product-thumb');
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      if (thumbs[currentIndex]) thumbs[currentIndex].classList.add('active');
      var mainImage = document.querySelector('.wtd-product-main-image img');
      if (mainImage && thumbs[currentIndex]) {
        var thumbImg = thumbs[currentIndex].querySelector('img');
        if (thumbImg) {
          mainImage.removeAttribute('srcset');
          mainImage.src = thumbImg.dataset.full || thumbImg.src;
          mainImage.alt = thumbImg.alt;
        }
      }
    }

    function openZoom(src, alt) {
      collectImages();
      // Fallback for single-image products with no thumbnails
      if (images.length === 0) {
        images.push({ src: src.replace(/width=\d+/, 'width=2000'), alt: alt || '' });
      }
      // Find which image we're opening
      currentIndex = 0;
      for (var i = 0; i < images.length; i++) {
        if (src.indexOf(images[i].src.split('?')[0].split('/').pop()) > -1 ||
            images[i].src.indexOf(src.split('?')[0].split('/').pop()) > -1) {
          currentIndex = i;
          break;
        }
      }
      showImage(currentIndex);
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeZoom() {
      syncMainImage();
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Click main product image to zoom
    document.addEventListener('click', function (e) {
      var mainImg = e.target.closest('.wtd-product-main-image img');
      if (!mainImg) return;
      var src = mainImg.src.replace(/width=\d+/, 'width=2000');
      openZoom(src, mainImg.alt);
    });

    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      showImage(currentIndex + 1);
    });

    closeBtn.addEventListener('click', closeZoom);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeZoom();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('active')) return;
      if (e.key === 'Escape') closeZoom();
      if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
      if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    });
  })();

  // ============================================
  // Cart — Quantity Controls
  // ============================================
  document.querySelectorAll('.wtd-cart-qty').forEach(function (qtyWrap) {
    var minus = qtyWrap.querySelector('[data-qty-minus]');
    var plus = qtyWrap.querySelector('[data-qty-plus]');
    var input = qtyWrap.querySelector('input');

    if (minus && input) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }

    if (plus && input) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }

    // Persist the new quantity to Shopify, then re-render the page so the
    // line price, subtotal, shipping bar, and header count all stay in sync.
    if (input && input.dataset.line) {
      input.addEventListener('change', function () {
        var quantity = parseInt(input.value, 10);
        if (isNaN(quantity) || quantity < 0) return;

        qtyWrap.classList.add('wtd-cart-qty--updating');
        input.disabled = true;
        if (minus) minus.disabled = true;
        if (plus) plus.disabled = true;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line: parseInt(input.dataset.line, 10),
            quantity: quantity
          })
        })
          .then(function (response) { return response.json(); })
          .then(function () { window.location.reload(); })
          .catch(function () { window.location.reload(); });
      });
    }
  });

  // ============================================
  // Add to Cart (AJAX)
  // ============================================
  document.querySelectorAll('.wtd-product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.textContent = 'Adding...';
        submitBtn.disabled = true;
      }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (submitBtn) {
            submitBtn.textContent = 'Added!';
            setTimeout(function () {
              submitBtn.textContent = originalText;
              submitBtn.disabled = false;
            }, 1500);
          }
          // Update cart count in header
          updateCartCount();
        })
        .catch(function (err) {
          if (submitBtn) {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }
          console.error('Add to cart error:', err);
        });
    });
  });

  // ============================================
  // Cart Count Update
  // ============================================
  function updateCartCount() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.wtd-cart-count').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });
      })
      .catch(function () {});
  }

  // Initial cart count
  if (window.routes && window.routes.cart_url) {
    updateCartCount();
  }

  // ============================================
  // Predictive Search
  // ============================================
  var searchToggle = document.querySelector('.wtd-search-toggle');
  var searchPanel = document.getElementById('predictiveSearch');
  var searchInput = document.getElementById('predictiveSearchInput');
  var searchResults = document.getElementById('predictiveSearchResults');
  var searchClose = searchPanel ? searchPanel.querySelector('.wtd-search-close') : null;
  var searchDebounce = null;

  if (searchToggle && searchPanel && searchInput) {
    function openSearch() {
      searchPanel.removeAttribute('hidden');
      searchToggle.setAttribute('aria-expanded', 'true');
      searchInput.focus();
    }

    function closeSearch() {
      searchPanel.setAttribute('hidden', '');
      searchToggle.setAttribute('aria-expanded', 'false');
      searchInput.value = '';
      searchResults.innerHTML = '';
    }

    searchToggle.addEventListener('click', function () {
      var isOpen = !searchPanel.hasAttribute('hidden');
      if (isOpen) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hasAttribute('hidden')) {
        closeSearch();
        searchToggle.focus();
      }
    });

    searchInput.addEventListener('input', function () {
      var query = searchInput.value.trim();
      clearTimeout(searchDebounce);

      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }

      searchDebounce = setTimeout(function () {
        fetchPredictiveResults(query);
      }, 300);
    });

    function fetchPredictiveResults(query) {
      var url = window.routes.search_url + '/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag';

      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
          renderSearchResults(products, query);
        })
        .catch(function () {
          searchResults.innerHTML = '';
        });
    }

    function formatMoneyCents(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function renderSearchResults(products, query) {
      if (products.length === 0) {
        searchResults.innerHTML = '<p class="wtd-search-no-results">No results for \u201C' + query + '\u201D</p>';
        return;
      }

      var html = '<ul class="wtd-search-results-list">';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var imgSrc = p.image ? p.image.replace(/(\.\w+)(\?|$)/, '_100x$1$2') : '';
        var price = p.price ? '$' + p.price : '';

        html += '<li>';
        html += '<a href="' + p.url + '" class="wtd-search-result-link">';
        if (imgSrc) {
          html += '<img class="wtd-search-result-img" src="' + imgSrc + '" alt="" loading="lazy">';
        }
        html += '<div class="wtd-search-result-info">';
        html += '<div class="wtd-search-result-title">' + p.title + '</div>';
        if (price) {
          html += '<div class="wtd-search-result-price">' + price + '</div>';
        }
        html += '</div>';
        html += '</a>';
        html += '</li>';
      }
      html += '</ul>';
      html += '<a href="' + window.routes.search_url + '?q=' + encodeURIComponent(query) + '" class="wtd-search-view-all">View all results</a>';

      searchResults.innerHTML = html;
    }
  }

  // ============================================
  // Park Modal (Inspiration page)
  // ============================================
  var parkModal = document.getElementById('parkModal');

  if (parkModal) {
    var modalImage = document.getElementById('parkModalImage');
    var modalName = document.getElementById('parkModalName');
    var modalMeta = document.getElementById('parkModalMeta');
    var modalDesc = document.getElementById('parkModalDesc');
    var modalOverline = document.getElementById('parkModalOverline');
    var modalClose = parkModal.querySelector('.wtd-modal-close');
    var modalBackdrop = parkModal.querySelector('.wtd-modal-backdrop');
    var previousFocus = null;

    function buildAccordion(elements) {
      var html = '<div class="wtd-accordion">';
      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        html += '<div class="wtd-accordion-item">';
        html += '<button class="wtd-accordion-trigger" type="button" aria-expanded="false">';
        html += '<span class="wtd-accordion-number">' + (i + 1) + '</span>';
        html += '<span class="wtd-accordion-title">' + el.title + '</span>';
        html += '<svg class="wtd-accordion-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="4 6 8 10 12 6"/></svg>';
        html += '</button>';
        html += '<div class="wtd-accordion-panel" hidden>';
        html += '<p>' + el.text + '</p>';
        html += '</div>';
        html += '</div>';
      }
      html += '</div>';
      return html;
    }

    function openParkModal(card) {
      var code = card.dataset.parkCode;
      var name = card.dataset.parkName;
      var state = card.dataset.parkState;
      var year = card.dataset.parkYear;
      var img = card.querySelector('img');
      var descriptions = window.parkDescriptions || {};
      var parkData = descriptions[code];

      previousFocus = document.activeElement;

      modalOverline.textContent = '';
      modalName.textContent = name;
      modalMeta.textContent = state + ' \u00B7 Est. ' + year;

      if (parkData && parkData.elements && parkData.elements.length > 0) {
        modalDesc.innerHTML = buildAccordion(parkData.elements);
        // Bind accordion toggle events
        modalDesc.querySelectorAll('.wtd-accordion-trigger').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            var panel = btn.nextElementSibling;
            if (expanded) {
              panel.setAttribute('hidden', '');
            } else {
              panel.removeAttribute('hidden');
            }
          });
        });
      } else {
        modalDesc.innerHTML = '<p class="wtd-modal-coming-soon">Design details coming soon.</p>';
      }

      if (img && img.src) {
        modalImage.src = img.src;
        modalImage.alt = name + ' National Park design';
      }

      var modalShop = document.getElementById('parkModalShop');
      if (modalShop) {
        if (card.dataset.parkShop) {
          modalShop.href = card.dataset.parkShop;
          modalShop.textContent = 'Shop ' + name;
          modalShop.removeAttribute('hidden');
        } else {
          modalShop.setAttribute('hidden', '');
        }
      }

      parkModal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      modalClose.focus();
    }

    function closeParkModal() {
      parkModal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (previousFocus) {
        previousFocus.focus();
      }
    }

    // Open on card click
    document.querySelectorAll('.wtd-inspo-card').forEach(function (card) {
      card.addEventListener('click', function () {
        openParkModal(card);
      });
    });

    // Close handlers
    modalClose.addEventListener('click', closeParkModal);
    modalBackdrop.addEventListener('click', closeParkModal);

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !parkModal.hasAttribute('hidden')) {
        closeParkModal();
      }
    });

    // Trap focus inside modal
    parkModal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = parkModal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

})();
